import { render, staticRenderFns } from "./TelecomContactBlock.vue?vue&type=template&id=d48119ea"
import script from "./TelecomContactBlock.vue?vue&type=script&lang=js"
export * from "./TelecomContactBlock.vue?vue&type=script&lang=js"
import style0 from "./TelecomContactBlock.vue?vue&type=style&index=0&id=d48119ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports